const messages = {
  cancel: 'Cancel',
  editProducts: 'Edit Products',
  errorWhileSaving: 'There was an error while trying to update the products.',
  loadingProducts: 'Loading Products',
  productsUpdated: 'Products have been updated.',
  productsSaving: 'Products Saving',
  productsAreSaving:
    'Your updates are saving. The Edit Products window will close automatically when the save is complete. Please stay on this page until then.',
  reloadProducts: 'Reload Products',
  save: 'Save',
  saveAndAdd: 'Save and add products',
}

export default messages
